
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
//import {Row, Col, Container, Card} from 'react-bootstrap';
import { Row, Col, Container, Card, Button, InputGroup } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';


// import Select from 'react-select';

const Classwise_Subject = () => {

  const [isEditable, setIsEditable] = useState(false);
  const [dropdowns, setDropdowns] = useState({ premTypes: [], mainComp: [] });
  const [ddlSection, setDdlSection] = useState([]);
  const [alluminiId, setAlluminiIdId] = useState('');
  const [stdId, setStdId] = useState(''); 
  const [ddlStandards, setDdlStandards] = useState([]);
  const [ddlSubjects, setDdlSubjects] = useState([]);
 

  // Header State
  const [headerData, setHeaderData] = useState({
    section_id: '',
    std_id: '',
    year1: '',
    year2: '',
    optional_sub: '',
  });

  const [savedfromDate, setSavedFromDate] = useState('');
  const [savedendDate, setSavedEndDate] = useState('');
  const [savedYear1, setSavedYear1] = useState('');

  // Child Table Data
  const [childRows, setChildRows] = useState([
    {
      css_id: '',
      year1: '',
      year2: '',
      section_id: '',
      std_id: '',
      sub_id: '',
      sub_type_id: '',
      sub_order: '',
      unit_oral_max: '',
      unit_writ_max: '',
      unit_writ_pass: '',
      sem_I_oral_max: '',
      sem_I_writ_max: '',
      sem_I_writ_pass: '',
      appl_final_semester: '',
      avg_marks_divider: '',
      subject_group: '',
      optional_subj: '',
      sem_II_oral_max: '',
      sem_II_writ_max: '',
      sem_II_writ_pass: '',
      publish_on_app: '',

    }
  ]);

  const handleHeaderChange = (e) => {
    const { name, value } = e.target;
    setHeaderData(prev => ({ ...prev, [name]: value }));
  };

  const handleChildChange = (index, e) => {
    const { name, value } = e.target;
    const updatedRows = [...childRows];
    updatedRows[index][name] = value;
    setChildRows(updatedRows);
  };


  useEffect(() => {
    const fetchLists = async () => {
      try {
        const sectionresult = await axios.get(`${BASE_URL}/api/ddl_allumini_sections`, { params: { p_Allumini: 'JRC' } });
        setDdlSection(sectionresult.data);

          // const res = await axios.get(`${BASE_URL}/api/ddl_standards`, { params: { p_Section_Id: headerData.section_id } });
          // setDdlStandards(res.data || []);

        //        console.log('premtypeRes.data =====> ', premtypeRes.data);
      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };
    fetchLists();
  }, []);

  useEffect(() => {
  
      if (!headerData.section_id) return;
  
      const fetchStandards = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/ddl_standards`, { params: { p_Section_Id: headerData.section_id } });
        setDdlStandards(res.data || []);
      } catch (error) {
        console.error("Error fetching subgroups:", error);
      }
    };
  
      fetchStandards();
  
    }, [headerData.section_id]);
  

  const addRow = () => {
    const newIndex = childRows.length + 1; // 1-based index
    const newRow = {
      parent_irn: '',
      maintId: '',
      dispOrder: newIndex, // Default to index + 1
      amount: ''
    };
    setChildRows([...childRows, newRow]);
    //setChildRows([...childRows, { parent_irn: '', maintId: '', dispOrder: '', amount: '' }]);
  };

  const removeRow = (index) => {
    const updatedRows = [...childRows];
    updatedRows.splice(index, 1);
    setChildRows(updatedRows);
  };

  const handleNew = () => {
    setIsEditable(true);
    setHeaderData({
      section_id: '',
      std_id: '',
      year1: '',
      year2: '',
      optional_sub: '',
    });
    setChildRows([{
      css_id: '',
      year1: '',
      year2: '',
      section_id: '',
      std_id: '',
      sub_id: '',
      sub_type_id: '',
      sub_order: '',
      unit_oral_max: '',
      unit_writ_max: '',
      unit_writ_pass: '',
      sem_I_oral_max: '',
      sem_I_writ_max: '',
      sem_I_writ_pass: '',
      appl_final_semester: '',
      avg_marks_divider: '',
      subject_group: '',
      optional_subj: '',
      sem_II_oral_max: '',
      sem_II_writ_max: '',
      sem_II_writ_pass: '',
      publish_on_app: '',

    }]);
  };

  const handleSave = async () => {

    // if (!headerData.fromDate || !headerData.toDate) {
    //   //speakMessage('From or To Date cannot be left blank.');
    //   alert('From or To Date cannot be left blank !');
    //   return;
    // }
    // else if (headerData.fromDate > headerData.toDate) {
    //   //speakMessage('From cannot be greater than To Date.');
    //   alert('From cannot be greater than To Date !');
    //   return;
    // }
    // else if (!headerData.premiseType || headerData.premiseType === '') {
    //   //speakMessage('Please Select Premise Type');
    //   alert('Please Select Premise Type !');
    //   return;
    // }

    let lv_err_msg = '';

    for (let i = 0; i < childRows.length; i++) {
      if (!childRows[i].maintId || childRows[i].maintId === '') {
        lv_err_msg = 'Please Select Maintenance Component at Row # ' + (i + 1);
        break;
      }
      else if (!childRows[i].dispOrder || childRows[i].maintId === '0') {
        lv_err_msg = 'Please enter Display Order at Row # ' + (i + 1);
        break;


      }
      else if (!childRows[i].amount || childRows[i].amount === '0' || childRows[i].amount < 0) {
        lv_err_msg = 'Please enter Maintenance Amount greater than 0 at Row # ' + (i + 1);
        break;
      }

    }

    if (lv_err_msg) {
      alert(lv_err_msg);
      return;
    }

    let lv_dupl = 0;

    for (let i = 0; i < childRows.length; i++) {
      for (let j = i + 1; j < childRows.length; j++) {
        if (childRows[i].maintId === childRows[j].maintId) {
          lv_dupl = j;
          break;
        }
      }
      if (lv_dupl > 0) {
        break;
      }
    }

    if (lv_dupl > 0) {
      playBeep();
      alert('Duplicate Maintenance Component selected at Row # ' + (lv_dupl + 1));
      return;
    }

    // DB Validation to check if the given From/To dates, Premise Type already exists or not

    const valResp = await axios.get(`${BASE_URL}/api/validate_maint_struct`,
      { params: { p_Year1: savedYear1, p_fromDate: headerData.fromDate, p_toDate: headerData.toDate, p_PremTypeId: headerData.premiseType } });

    if (valResp.data[0].rows_count > 0) {
      playBeep();
      //speakMessage('Maintenance Structure already exists for the given Year, From, To Dates and Premise Type');
      alert('Maintenance Structure already exists for the given Year, From, To Dates and Premise Type !');
      return;
    }

    // console.log('valResp.data ===> ', valResp.data); 
    // console.log('valResp.data[0].rows_count ===> ', valResp.data[0].rows_count); 

    const isConfirmed = window.confirm("Sure you want to Save the record ?");

    if (!isConfirmed) return;

    const structdata = {
      header: headerData,
      details: childRows,
    };

    const response = await axios.post(`${BASE_URL}/api/save_maint_struct`, structdata);

    if (response.data.message === '1') {
      //alert('Maintenance Structure saved successfully !');
      speakMessage('Maintenance Structure saved successfully. Do you like to Add more ?');
      if (window.confirm("Maintenance Structure saved successfully. Do you like to Add more ?")) {
        //headerData.premiseType = '';
        //setDropdowns.premTypes('');
        const updatedChildRows = childRows.map(row => ({
          ...row,
          amount: ''
        }));
        setChildRows(updatedChildRows);
      }
      else {
        setIsEditable(false);
        setHeaderData({
          section_id: '',
          std_id: '',
          year1: '',
          year2: '',
          optional_sub: '',
        });
        setChildRows([{
          css_id: '',
          year1: '',
          year2: '',
          section_id: '',
          std_id: '',
          sub_id: '',
          sub_type_id: '',
          sub_order: '',
          unit_oral_max: '',
          unit_writ_max: '',
          unit_writ_pass: '',
          sem_I_oral_max: '',
          sem_I_writ_max: '',
          sem_I_writ_pass: '',
          appl_final_semester: '',
          avg_marks_divider: '',
          subject_group: '',
          optional_subj: '',
          sem_II_oral_max: '',
          sem_II_writ_max: '',
          sem_II_writ_pass: '',
          publish_on_app: '',


        }]);
        headerData.fromDate = savedfromDate;
        headerData.toDate = savedendDate;
      }
    }

  };

  const handleClear = () => {
    if (window.confirm("Clear all data?")) {
      handleNew();
      setIsEditable(false);
    }
  };

  const playBeep = () => {
    const audioCtx = new (window.AudioContext || window.AudioContext)();
    const oscillator = audioCtx.createOscillator();
    const gainNode = audioCtx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioCtx.destination);

    oscillator.type = 'square'; // Other types: sine, square, triangle, sawtooth
    oscillator.frequency.setValueAtTime(440, audioCtx.currentTime); // Frequency in Hz (440Hz = A4 note)
    gainNode.gain.setValueAtTime(0.1, audioCtx.currentTime); // Volume

    oscillator.start();
    oscillator.stop(audioCtx.currentTime + 0.2); // Play for 0.2 seconds
  };

  const speakMessage = (message) => {
    const utterance = new SpeechSynthesisUtterance(message);
    utterance.lang = 'en-US'; // or 'en-GB', 'hi-IN', etc.
    utterance.rate = 1;       // Speed: 0.1 (slow) to 10 (fast)
    utterance.pitch = 1;      // Pitch: 0 to 2
    speechSynthesis.speak(utterance);
  };

  return (
    <Container fluid className="p-3">
      <Card className="mb-4 p-3">

        {<Row className="mb-3">

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Section
              </InputGroup.Text>
              <select
                className="form-select"
                name="section_id"
                value={headerData.section_id}
                disabled={!isEditable}
                onChange={(e) => handleHeaderChange(e)}
              >
                <option value="">-- Select Section--</option>
                {ddlSection.map(sec => (
                  <option key={sec.section_id} value={sec.section_id}>{sec.section_desc}</option>
                ))}

              </select>
            </InputGroup>
          </Col>


          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Standard
              </InputGroup.Text>
              <select
                className="form-select"
                name="std_id"
                value={headerData.std_id}
                disabled={!isEditable}
                onChange={(e) => setHeaderData(e.target.value)}
              >
                <option value="">-- Select Standard--</option>
                {ddlStandards.map(std => (
                  <option key={std.std_id} value={std.std_id}>{std.std_name}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Year 1 <span style={{ color: "red" }}>*</span>
              </InputGroup.Text>
              <input
                type="number"
                style={{ textAlign: 'right' }}
                className="form-control"
                name="year1"
                value={headerData.year1}
                disabled={!isEditable}
              // onChange={handleChange}
              />&nbsp;
              <input
                type="number"
                style={{ textAlign: 'right' }}
                className="form-control"
                name="year2"
                value={headerData.year2}
                disabled={!isEditable}
              // onChange={handleChange}
              />
            </InputGroup>
          </Col>
          <Row className="mb-3"></Row>
          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "150px" }}>
                Optional Subject {/* <span style={{ color: "red" }}>*</span> */}
              </InputGroup.Text>
              <input
                type="text"
                style={{ textAlign: 'right' }}
                className="form-control"
                name="optional_sub"
                value={headerData.optional_sub}
                disabled={!isEditable}
              // onChange={handleChange}
              />
            </InputGroup>
          </Col>
        </Row>}



        <div className="d-flex justify-content-end gap-2 mt-3 flex-wrap">

          <button
            type="button"
            className="btn btn-primary"
            style={{ width: "135px" }}
            onClick={handleNew}
            disabled={isEditable}
          >New
          </button>

          <button
            type="button"
            className="btn btn-secondary"
            style={{ width: "135px" }}
            onClick={handleClear}
          > Clear
          </button>

          <button
            type="button"
            className="btn btn-success"
            style={{ width: "135px" }}
            onClick={handleSave}
            disabled={!isEditable}
          > Save
          </button>
        </div>
      </Card>

      {/* Child Table */}

      <Card className="p-3">
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table-parking scty-custom-table hover-table-rcpt">
            <thead>
              <tr>
                <th style={{ width: '5%', textAlign: 'center' }}>#</th>
                <th style={{ width: '20%', textAlign: 'left' }}>Subject</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Subject Type</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Subject Order</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Unit Oral/Pract Max</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Unit Written Pass</th>
                <th style={{ width: '8%', textAlign: 'left' }}>Unit Written Max</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Sem-I Oral/Pract</th>
                <th style={{ width: '8%', textAlign: 'left' }}>Sem Written <br />Pass</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Sem Written Max</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Sem-II Oral/Pract</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Sem-II Written <br />Pass</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Sem-II Written <br />Max</th>
                <th style={{ width: '7%', textAlign: 'left' }}>Appl. Final</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Average</th>
                <th style={{ width: '7%', textAlign: 'left' }}></th>
              </tr>
            </thead>


            {/* css_id: '',
          year1: '',
          year2: '',
          section_id: '',
          std_id: '',
          sub_id: '',
          sub_type_id: '',
          sub_order: '',
          unit_oral_max: '',
          unit_writ_max: '',
          unit_writ_pass: '',
         sem__oral_max: '',
         sem__writ_max: '',
         sem__writ_pass: '',
          appl_final_semester: '',
          avg_marks_divider: '',
          subject_group: '',
          optional_subj: '',
        sem_II_oral_max: '',
        sem_II_writ_max: '',
        sem_II_writ_pass: '',
          publish_on_app: '', */}

            <tbody>
              {childRows.map((row, index) => (
                <tr key={index}>
                  <td style={{ width: "5%", textAlign: 'center' }}>{index + 1}</td>
                  <td>
                    <select className="form-select" disabled={!isEditable}
                      name="sub_id" value={row.sub_id} onChange={(e) => handleChildChange(index, e)}>
                      <option value="0">Select Subject </option>
                       {ddlSubjects.map(sub => (
                    <option key={sub.sub_id} value={sub.sub_id}>{sub.sub_desc}</option>
                  ))}
                    </select>
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="number" className="form-control" name=" sub_type_id" value={row.sub_type_id} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="text" className="form-control" name="sub_order" value={row.sub_order} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="text" className="form-control" name="unit_oral_max" value={row.unit_oral_max} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="text" className="form-control" name="unit_writ_pass" value={row.unit_writ_pass} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="text" className="form-control" name=" unit_writ_max" value={row.unit_writ_max} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="text" className="form-control" name=" sem_I_oral_max" value={row.sem_I_oral_max} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="text" className="form-control" name="sem_I_writ_pass" value={row.sem_I_writ_pass} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="text" className="form-control" name="sem_I_writ_max" value={row.sem_I_writ_max} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="text" className="form-control" name="sem_II_oral_max" value={row.sem_II_oral_max} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="text" className="form-control" name="sem_II_writ_pass" value={row.sem_II_writ_pass} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="text" className="form-control" name="sem_II_writ_max" value={row.sem_II_writ_max} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="appl_final_semester"
                      checked={row.avg_marks_divider === 1 || row.avg_marks_divider === true}
                      disabled={!isEditable}
                      onChange={(e) =>
                        handleChildChange(index, {
                          target: {
                            name: "appl_final_semester",
                            value: e.target.checked ? 1 : 0
                          }
                        })
                      }
                    />
                  </td>

                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="text" className="form-control" name="avg_marks_divider" value={row.avg_marks_divider} onChange={(e) => handleChildChange(index, e)} />
                  </td>

                  <td style={{ textAlign: 'center' }}>
                    {childRows.length > 1 && (
                      <Button variant="danger" onClick={() => removeRow(index)} size="sm">Delete</Button>
                    )}
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mb-3">
          <Button disabled={!isEditable} style={{ marginTop: '10px' }} variant="primary" onClick={addRow}>Add Row</Button>
        </div>
      </Card>

      {/* Buttons */}
    </Container>
  );
};

export default Classwise_Subject;
